import { useEffect } from 'react';
export function useLiveChatConnected(isLiveChatConnected, almeAppConfig, setAlmeAppConfig) {
    useEffect(() => {
        if (isLiveChatConnected && !almeAppConfig.notificationApi.pollForLiveChat) {
            setAlmeAppConfig(Object.assign(Object.assign({}, almeAppConfig), { notificationApi: Object.assign(Object.assign({}, almeAppConfig.notificationApi), { pollForLiveChat: true }) }));
        }
        else if (!isLiveChatConnected && almeAppConfig.notificationApi.pollForLiveChat) {
            setAlmeAppConfig(Object.assign(Object.assign({}, almeAppConfig), { notificationApi: Object.assign(Object.assign({}, almeAppConfig.notificationApi), { pollForLiveChat: false }) }));
        }
    }, [almeAppConfig, isLiveChatConnected, setAlmeAppConfig]);
}
